function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1984(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.1,
    height: 12.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4739999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 6.185,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.37,
    width: 20.1,
    height: 12.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 18.674999999999997,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.98,
    width: 20.1,
    height: 14.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 32.31,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.64,
    width: 20.1,
    height: 14.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9699999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 47.065,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54.49,
    width: 20.1,
    height: 15.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.245714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 62.35,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70.21,
    width: 20.1,
    height: 16.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3560000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 78.6,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.99,
    width: 20.1,
    height: 17.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.876666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 95.61999999999999,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 104.25,
    width: 20.1,
    height: 18.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6471428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 113.515,
    fontFamily: "Arial"
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122.79,
    width: 20.1,
    height: 19.45,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7785714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 132.51500000000001,
    fontFamily: "Arial"
  }, "\n        Edwards\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 142.24,
    width: 20.1,
    height: 20.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 152.51000000000002,
    fontFamily: "Arial"
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.78,
    width: 20.1,
    height: 20.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 173.18,
    fontFamily: "Arial"
  }, "\n        Gallatin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 183.58,
    width: 20.1,
    height: 21.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 194.4,
    fontFamily: "Arial"
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 205.22,
    width: 20.1,
    height: 24.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 217.265,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.31,
    width: 20.1,
    height: 25.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8714285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 242.165,
    fontFamily: "Arial"
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 255.02,
    width: 20.1,
    height: 27.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 268.54,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 282.06,
    width: 20.1,
    height: 27.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 295.85,
    fontFamily: "Arial"
  }, "\n        Wabash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 309.65,
    width: 20.1,
    height: 27.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 323.445,
    fontFamily: "Arial"
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 337.24,
    width: 20.1,
    height: 27.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 351.065,
    fontFamily: "Arial"
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 364.89,
    width: 20.1,
    height: 29.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 379.47499999999997,
    fontFamily: "Arial"
  }, "\n        Menard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 394.06,
    width: 20.1,
    height: 30.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 409.415,
    fontFamily: "Arial"
  }, "\n        Moultrie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 424.77,
    width: 20.1,
    height: 32.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 440.955,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 457.14,
    width: 20.1,
    height: 32.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 473.56,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 489.99,
    width: 20.1,
    height: 33.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 506.82,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 523.65,
    width: 20.1,
    height: 33.7,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 540.5,
    fontFamily: "Arial"
  }, "\n        Ford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 557.36,
    width: 20.1,
    height: 34.98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 574.85,
    fontFamily: "Arial"
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.34,
    width: 20.1,
    height: 35.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 610.1700000000001,
    fontFamily: "Arial"
  }, "\n        Massac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.99,
    width: 20.1,
    height: 35.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 645.96,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 663.93,
    width: 20.1,
    height: 36.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.05,
    y: 681.9649999999999,
    fontFamily: "Arial"
  }, "\n        Bond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 0,
    width: 25.99,
    height: 29.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1979999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.095,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.09,
    y: 0,
    width: 26.09,
    height: 29.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.609
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 59.135000000000005,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 0,
    width: 26.51,
    height: 29.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.31375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.435,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.69,
    y: 0,
    width: 26.58,
    height: 29.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7971428571428567
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.97999999999999,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.27,
    y: 0,
    width: 27.33,
    height: 29.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.41625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.935,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.61,
    y: 0,
    width: 27.35,
    height: 29.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.470000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.28500000000003,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Piatt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.96,
    y: 0,
    width: 29.1,
    height: 29.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.51000000000002,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.06,
    y: 0,
    width: 29.73,
    height: 29.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.925,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.78,
    y: 0,
    width: 29.87,
    height: 29.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.184285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.715,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268.65,
    y: 0,
    width: 30.99,
    height: 29.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.881666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.145,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.64,
    y: 0,
    width: 31.01,
    height: 29.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.881666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.145,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Jersey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.65,
    y: 0,
    width: 31.07,
    height: 29.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.185,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.72,
    y: 0,
    width: 31.18,
    height: 29.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.31,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.91,
    y: 0,
    width: 31.91,
    height: 29.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.881666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.865,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.82,
    y: 0,
    width: 32.23,
    height: 29.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.3225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.935,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.05,
    y: 0,
    width: 32.29,
    height: 29.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.929
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.195,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Jo_Daviess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.34,
    y: 0,
    width: 32.71,
    height: 29.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.66125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.695,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.05,
    y: 0,
    width: 34.72,
    height: 29.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.184285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.41,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.77,
    y: 0,
    width: 35.06,
    height: 29.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.3,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Edgar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.83,
    y: 0,
    width: 35.47,
    height: 29.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.881666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.565,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.29,
    y: 0,
    width: 36.35,
    height: 29.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.4649999999999,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 663.64,
    y: 0,
    width: 36.36,
    height: 29.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.184285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.8199999999999,
    y: 14.645,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 29.29,
    width: 37.06,
    height: 29.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.906666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 44.01,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 58.73,
    width: 37.06,
    height: 31.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.204
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 74.24,
    fontFamily: "Arial"
  }, "\n        Boone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 89.75,
    width: 37.06,
    height: 36.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 107.925,
    fontFamily: "Arial"
  }, "\n        Saline\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 126.1,
    width: 37.06,
    height: 37.05,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.116666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 144.625,
    fontFamily: "Arial"
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 163.15,
    width: 37.06,
    height: 38.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2942857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 182.215,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 201.28,
    width: 37.06,
    height: 38.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.117777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 220.485,
    fontFamily: "Arial"
  }, "\n        McDonough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 239.69,
    width: 37.06,
    height: 38.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.412000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 258.96,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 278.23,
    width: 37.06,
    height: 39.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.176666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 297.88,
    fontFamily: "Arial"
  }, "\n        Grundy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 317.53,
    width: 37.06,
    height: 40.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7060000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 337.565,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 357.6,
    width: 37.06,
    height: 40.29,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 377.745,
    fontFamily: "Arial"
  }, "\n        Iroquois\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 397.89,
    width: 37.06,
    height: 40.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2942857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 418.09499999999997,
    fontFamily: "Arial"
  }, "\n        Kendall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 438.3,
    width: 37.06,
    height: 41.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.353333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 459.09000000000003,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 479.88,
    width: 37.06,
    height: 41.9,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 500.83,
    fontFamily: "Arial"
  }, "\n        Woodford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 521.77,
    width: 37.06,
    height: 43.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 543.485,
    fontFamily: "Arial"
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 565.2,
    width: 37.06,
    height: 44.16,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.176666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 587.2800000000001,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 609.36,
    width: 37.06,
    height: 44.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.117777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 631.515,
    fontFamily: "Arial"
  }, "\n        Christian\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 653.68,
    width: 37.06,
    height: 46.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.117777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.63,
    y: 676.8399999999999,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 29.29,
    width: 38.56,
    height: 44.62,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8560000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.44,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.72,
    y: 29.29,
    width: 41.88,
    height: 44.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.66,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.6,
    y: 29.29,
    width: 41.92,
    height: 44.62,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.56,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Ogle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.53,
    y: 29.29,
    width: 42.77,
    height: 44.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.128333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.915,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Bureau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.29,
    y: 29.29,
    width: 43.18,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.196666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.88,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.47,
    y: 29.29,
    width: 46.44,
    height: 44.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.69000000000005,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.91,
    y: 29.29,
    width: 48.16,
    height: 44.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.99,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Stephenson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.07,
    y: 29.29,
    width: 48.53,
    height: 44.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.335,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Coles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.6,
    y: 29.29,
    width: 52.31,
    height: 44.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.755,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Macoupin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.91,
    y: 29.29,
    width: 57.57,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.69500000000005,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.48,
    y: 29.29,
    width: 59.02,
    height: 44.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.374285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.99,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.5,
    y: 29.29,
    width: 60.69,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.845,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Williamson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.19,
    y: 29.29,
    width: 61.81,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.095,
    y: 51.599999999999994,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 73.91,
    width: 61.58,
    height: 46.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.154444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 97.10499999999999,
    fontFamily: "Arial"
  }, "\n        Whiteside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 120.3,
    width: 61.58,
    height: 50.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.120000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 145.6,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 170.9,
    width: 61.58,
    height: 51.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.658333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 196.875,
    fontFamily: "Arial"
  }, "\n        DeWitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 222.85,
    width: 61.58,
    height: 65.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.842222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 255.55,
    fontFamily: "Arial"
  }, "\n        Vermilion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 288.25,
    width: 61.58,
    height: 65.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 320.995,
    fontFamily: "Arial"
  }, "\n        Kankakee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 353.74,
    width: 61.58,
    height: 79.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.797142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 393.48,
    fontFamily: "Arial"
  }, "\n        LaSalle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 433.22,
    width: 61.58,
    height: 79.83,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.263333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 473.13500000000005,
    fontFamily: "Arial"
  }, "\n        McLean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 513.05,
    width: 61.58,
    height: 92.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.315999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 559.375,
    fontFamily: "Arial"
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.16,
    y: 605.7,
    width: 61.58,
    height: 94.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.94999999999999,
    y: 652.85,
    fontFamily: "Arial"
  }, "\n        Tazewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.75,
    y: 73.91,
    width: 75.1,
    height: 84,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.728571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.3,
    y: 115.91,
    fontFamily: "Arial"
  }, "\n        McHenry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.84,
    y: 73.91,
    width: 81.01,
    height: 84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.001111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 234.345,
    y: 115.91,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.85,
    y: 73.91,
    width: 91.59,
    height: 84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.636363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.64500000000004,
    y: 115.91,
    fontFamily: "Arial"
  }, "\n        Rock_Island\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.44,
    y: 73.91,
    width: 100.34,
    height: 84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.61,
    y: 115.91,
    fontFamily: "Arial"
  }, "\n        Peoria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.79,
    y: 73.91,
    width: 107.15,
    height: 84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.365,
    y: 115.91,
    fontFamily: "Arial"
  }, "\n        Sangamon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.94,
    y: 73.91,
    width: 126.06,
    height: 84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.97,
    y: 115.91,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.75,
    y: 157.91,
    width: 115.91,
    height: 92.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.0625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.70499999999998,
    y: 204.035,
    fontFamily: "Arial"
  }, "\n        Kane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.75,
    y: 250.16,
    width: 115.91,
    height: 92.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.248571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.70499999999998,
    y: 296.53,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.75,
    y: 342.9,
    width: 115.91,
    height: 96.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.668888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.70499999999998,
    y: 390.90999999999997,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.75,
    y: 438.91,
    width: 115.91,
    height: 109.13,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.2825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.70499999999998,
    y: 493.475,
    fontFamily: "Arial"
  }, "\n        Will\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.75,
    y: 548.04,
    width: 115.91,
    height: 151.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.9775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.70499999999998,
    y: 624.02,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.65,
    y: 157.91,
    width: 465.35,
    height: 65.6,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.933333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.32500000000005,
    y: 190.70999999999998,
    fontFamily: "Arial"
  }, "\n        DuPage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.65,
    y: 223.51,
    width: 465.35,
    height: 476.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 116.3375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.32500000000005,
    y: 461.755,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1984);
export default __webpack_public_path__ + "static/media/1984.84a1506de3cc742c81749bf10c847c3a.svg";
export { ForwardRef as ReactComponent };